module.exports = __webpack_public_path__ + "a15309964988ec4839b47b1f2e15f620.jpg";